import React from "react";
import { TimePicker as ReactTimePicker } from "react-time-picker";
import cn from "classnames";

import "react-time-picker/dist/TimePicker.css";
import styles from "./styles.module.scss";

export const TimePicker = ({ label, value, onChange, className }) => (
  <div className={cn(styles.container, className)}>
    {!!label && <label className={styles.label}>{label}:</label>}
    <ReactTimePicker
      value={value}
      onChange={onChange}
      disableClock
      clearIcon={null}
      clockIcon={null}
      maxDetail="second"
      className={styles.timePicker}
      format="HH:mm:ss"
    />
  </div>
);
